import {useState, useMemo, useEffect} from 'react';
import {makeStyles} from '@material-ui/styles';
import IndexHeader from './IndexHeader';
import IndexTabs from './IndexTabs';

import TemplateListing from './Listing/TemplateListing';
import {getTemplates} from '../../../firebase';
import Loading from 'components/Loading';


function TemplatesIndex({handleOpenNewTemplate}) {
  const styles = useStyles();
  const [currentTab, setCurrentTab] = useState('ACTIVE');
  const [templates, setTemplates] = useState([]);
  const [loaded, setLoaded] = useState(false);


  const getTemplateList = async () => {
    try {
      const response = await getTemplates();
      setTemplates(response);
      setLoaded(true);
    } catch (e) {
      console.log(e)
    }

  }

  useEffect(() => {
    getTemplateList();
  },[])

  return (
    loaded ?
    <div className={styles.templatesIndex}>
      <IndexHeader title={'Templates'} />
      <IndexTabs
        currentTab={currentTab}
       // handleChange={onTabChange}
        tabs={[
          {value: 'ACTIVE', label: `Template List`},
        ]}
      />
      <TemplateListing templates={templates} handleOpenNewTemplate={handleOpenNewTemplate} />
    </div>
      : <Loading/>
  );
}

const useStyles = makeStyles({
  templatesIndex: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '25px',
  },
  emptyText: {
    textAlign: 'center',
  },
});

export default TemplatesIndex;
